import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  FormLabel,
} from "@material-ui/core";
import { ColorPicker, createColor } from "material-ui-color";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
//get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage")
);
const lan = localStorage.getItem("LangCode");
const menukey = "asset-status-entry";

const AssetstatusFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  handleChangeColorAdd,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  const handleChangeColor = (name) => {
    if (typeof name == "string") {
      formData["colorCode"] = name;
      handleChangeColorAdd(name);
    } else {
      formData["colorCode"] = name.css.backgroundColor;
      handleChangeColorAdd(name.css.backgroundColor);
    }
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Asset Status - Add/Edit"]}
              </div>
            </div>
            <div className="float-right sw_btn_control">
              {addProductForm ? (
                <Grid item xs={12} className="text-center">
                  <div className="float-right sw_btn_control">
                    <Button
                      className="mr-2"
                      variant="contained"
                      type="reset"
                      onClick={() => handleReset()}>
                      {DispensingLanguage[lan][menukey]["Reset"]}
                    </Button>
                    <Button
                      className="mr-2"
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit()}>
                      {DispensingLanguage[lan][menukey]["Save"]}
                    </Button>
                    <Button
                      className="mr-2"
                      variant="contained"
                      type="reset"
                      onClick={() =>
                        props.history.push("/asset-status-entry")
                      }>
                      {DispensingLanguage[lan][menukey]["Cancel"]}
                    </Button>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} className="mt-2 text-center">
                  <Button
                    className="mr-2"
                    variant="contained"
                    color="primary"
                    onClick={() => handleUpdate()}>
                    {DispensingLanguage[lan][menukey]["update"]}
                  </Button>
                  <Button
                    className="mr-2"
                    variant="contained"
                    type="reset"
                    onClick={() => props.history.push("/asset-status-entry")}>
                    {DispensingLanguage[lan][menukey]["Cancel"]}
                  </Button>
                </Grid>
              )}
            </div>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={3}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={5} sm={5}>
                        <TextField
                          error={errorObject.MStatus}
                          helperText={errorObject.MStatus}
                          required
                          id="MStatus"
                          name="MStatus"
                          label={
                            DispensingLanguage[lan][menukey]["Present Status"]
                          }
                          inputProps={{ maxLength: 50 }}
                          value={formData.MStatus}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={4} sm={4}>
                        <TextField
                          error={errorObject.SLNUMBER}
                          helperText={errorObject.SLNUMBER}
                          required
                          id="SLNUMBER"
                          name="SLNUMBER"
                          type="text"
                          inputProps={{ maxLength: 6 }}
                          label={DispensingLanguage[lan][menukey]["SLNUMBER"]}
                          value={formData.SLNUMBER}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <FormLabel component="legend">
                          {DispensingLanguage[lan][menukey]["Color Code"]}
                        </FormLabel> 

                        <ColorPicker
                          error={errorObject.colorCode}
                          helperText={errorObject.colorCode}
                          required
                          name="colorCode"
                          defaultValue="#00aabb"
                          value={formData.colorCode}
                          onChange={handleChangeColor}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default AssetstatusFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
